  import React, { useState, useEffect } from "react";
  import { Plus, Edit, Trash } from "lucide-react";
  import { useNavigate } from "react-router-dom";
  import apiService from "../services/apiService";

  const Characters = () => {
    const navigate = useNavigate();
    const [Characters, setCharacters] = useState([]);
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [selectedCharacterId, setSelectedCharacterId] = useState(null);
    const [offset, setOffset] = useState(0);
    const [totalCount, setTotalCount] = useState(0);
    const limit = 20;
    const [selectedIds, setSelectedIds] = useState([]);

    useEffect(() => {
      const token = localStorage.getItem("token");
      if (token) {
        fetchCharacter();
      } else {
        navigate("/");
      }
    }, [navigate, offset]);

    const fetchCharacter = async () => {
      try {
        const response = await apiService.postData("admin/character-list", {
          limit,
          offset,
        });
        if (response?.data?.rows) {
          setCharacters(response.data.rows);
          setTotalCount(response.data.count || 0);
        }
      } catch (error) {
        console.error("Error fetching Characters:", error);
      }
    };

    const handleEdit = (characterId) => navigate(`/edit-character/${characterId}`);

    const openModal = (characterId) => {
      setSelectedCharacterId(characterId);
      setIsModalOpen(true);
    };

    const handleDelete = async () => {
      if (selectedCharacterId) {
        try {
          await apiService.deleteData(`admin/character/${selectedCharacterId}`);
          setIsModalOpen(false);
          setSelectedCharacterId(null);
          fetchCharacter();
        } catch (error) {
          console.error("Error deleting character:", error);
        }
      }
    };

    const totalPages = Math.ceil(totalCount / limit);
    const currentPage = Math.floor(offset / limit) + 1;
    const renderPagination = () => {
      const pageButtons = [];
      const maxButtons = 5;
      const halfRange = Math.floor(maxButtons / 2);

      if (totalPages <= maxButtons) {
        for (let i = 1; i <= totalPages; i++) {
          pageButtons.push(i);
        }
      } else {
        let startPage = Math.max(1, currentPage - halfRange);
        let endPage = Math.min(totalPages, currentPage + halfRange);

        if (startPage > 1) pageButtons.push(1);
        if (startPage > 2) pageButtons.push("...");

        for (let i = startPage; i <= endPage; i++) {
          pageButtons.push(i);
        }

        if (endPage < totalPages - 1) pageButtons.push("...");
        if (endPage < totalPages) pageButtons.push(totalPages);
      }

      return pageButtons.map((page, index) =>
        typeof page === "number" ? (
          <button
            key={index}
            className={`btn mx-1 ${currentPage === page ? "btn-primary" : "btn-outline-primary"}`}
            onClick={() => setOffset((page - 1) * limit)}
          >
            {page}
          </button>
        ) : (
          <span key={index} className="btn mx-1 disabled">
            {page}
          </span>
        )
      );
    };

    const handleCheckboxChange = (chapterId) => {
      setSelectedIds((prev) =>
        prev.includes(chapterId)
          ? prev.filter((id) => id !== chapterId)
          : [...prev, chapterId]
      );
    };
    
    const handleBulkDelete = async () => {
      try {
        await apiService.postData("admin/delete-multiple-character", {
          character_id: selectedIds,
        });
        setCharacters((prev) =>
          prev.filter((c) => !selectedIds.includes(c.character_id))
        );
        setSelectedIds([]);
      } catch (error) {
        console.error("Error deleting selected characters:", error);
      }
    };
        

    return (
      <div className="container">
        <div className="card">
          <div className="card-header d-flex justify-content-between">
            <h4>Characters</h4>
            <div>
            {selectedIds.length > 0 && (
  <button
    onClick={handleBulkDelete}
    className="btn btn-danger me-2"
  >
    Delete Selected <Trash size={16} />
  </button>
)}

            <button
              onClick={() => navigate("/new-characters")}
              className="btn btn-primary"
            >
              New Characters <Plus size={16} />
            </button>
            </div>

          </div>
          <div className="card-body p-0">
            <div className="table-responsive">
              <table className="table table-bordered">
                <thead>
                  <tr>
                  <th>
    <input
      type="checkbox"
      onChange={(e) =>
        setSelectedIds(
          e.target.checked ? Characters.map((c) => c.character_id) : []
        )
      }
      checked={Characters.length > 0 && selectedIds.length === Characters.length}
    />
  </th>

                    <th>Content Title</th>
                    <th>Character Name</th>
                    <th>Description</th>
                    <th>Character Image</th>
                    <th>Action</th>
                  </tr>
                </thead>
                <tbody>
                  {Characters.map((character) => (
                    <tr key={character.character_id}>
                      <td>
    <input
      type="checkbox"
      checked={selectedIds.includes(character.character_id)}
      onChange={() => handleCheckboxChange(character.character_id)}
    />
  </td>
                      <td>{character.CharactersToContentDetails?.title || "-"}</td>
                      <td>{character.character_name || "-"}</td>
                      <td>{character.character_desc || "-"}</td>
                      <td>
    <img
      src={apiService.getFullImageUrl(character.character_img || "-")}
      alt="Character"
      style={{ width: '60px', height: '60px', objectFit: 'contain' }}
    />
  </td>
                    
                      <td>
    <div className="dropdown">
      <button
        className="btn btn-outline-primary btn-sm dropdown-toggle"
        type="button"
        id={`dropdownMenuButton${character.character_id}`}
        data-bs-toggle="dropdown"
        aria-expanded="false"
      >
        Action
      </button>
      <ul
        className="dropdown-menu"
        aria-labelledby={`dropdownMenuButton${character.character_id}`}
      >
        <li>
          <button
            className="dropdown-item"
            onClick={() => handleEdit(character.character_id)}
          >
            <Edit size={14} className="me-2" />
            Edit
          </button>
        </li>
        <li>
          <button
            className="dropdown-item text-danger"
            onClick={() => openModal(character.character_id)}
          >
            <Trash size={14} className="me-2" />
            Delete
          </button>
        </li>
      </ul>
    </div>
  </td>

                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>

          <nav className="d-flex justify-content-center my-3">
          <button
            className="btn btn-outline-primary me-2"
            onClick={() => setOffset(offset - limit)}
            disabled={offset === 0}
          >
            «
          </button>
          {renderPagination()}
          <button
            className="btn btn-outline-primary ms-2"
            onClick={() => setOffset(offset + limit)}
            disabled={offset + limit >= totalCount}
          >
            »
          </button>
        </nav>
        </div>

        {isModalOpen && (
          <div className="modal fade show d-block" style={{ backgroundColor: "rgba(0, 0, 0, 0.5)" }}>
            <div className="modal-dialog">
              <div className="modal-content">
                <div className="modal-header">
                  <h5 className="modal-title">Confirm Deletion</h5>
                  <button type="button" className="btn-close" onClick={() => setIsModalOpen(false)}></button>
                </div>
                <div className="modal-body">
                  <p>Are you sure you want to delete this character?</p>
                </div>
                <div className="modal-footer">
                  <button className="btn btn-danger" onClick={handleDelete}>Yes</button>
                  <button className="btn btn-secondary" onClick={() => setIsModalOpen(false)}>No</button>
                </div>
              </div>
            </div>
          </div>
        )}
      </div>
    );
  };

  export default Characters;
